// extracted by mini-css-extract-plugin
module.exports = {"Link":"nmDMSX","Icon":"hOaivs","Novita":"oM3EZX","Subtitle":"Y3eY9n"};